import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { VueContext } from 'vue-context';
import Axios from 'axios';
import '@/assets/main.css';

const apiEndpoint = process.env.VUE_APP_API_ENDPOINT;
Axios.defaults.baseURL = `http://${apiEndpoint}/api/`;
Axios.defaults.headers.common['Accept'] = 'application/json';

Axios.interceptors.request.use(config => {
  const token = store.getters['auth/getToken'];
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

Axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 403) {
      console.warn('Access forbidden:', error.response);
      // router.push({ name: 'Forbidden' });
    }
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false;

const initApp = async () => {
  try {
    await store.dispatch('auth/initializeAuth');

    new Vue({
      router,
      store,
      vuetify,
      VueContext,
      render: h => h(App)
    }).$mount('#app');
    
  } catch (err) {
    console.error('App initialization failed:', err);
  }
};

initApp();
